// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";

function fill(v) {
  return [
    v,
    v,
    v
  ];
}

function map(param, f) {
  return [
    f(param[0]),
    f(param[1]),
    f(param[2])
  ];
}

function reduce(param, init, f) {
  return Stdlib_Array.reduce([
    param[0],
    param[1],
    param[2]
  ], init, f);
}

function zipWith(f, param, param$1) {
  return [
    f(param[0], param$1[0]),
    f(param[1], param$1[1]),
    f(param[2], param$1[2])
  ];
}

function jsonCodec(elementCodec) {
  let arrayCodec = Jzon.array(elementCodec);
  return Jzon.custom(param => Jzon.encodeWith([
    param[0],
    param[1],
    param[2]
  ], arrayCodec), json => {
    let match = Jzon.decodeWith(json, arrayCodec);
    if (match.TAG === "Ok") {
      let match$1 = match._0;
      if (match$1.length === 3) {
        let a = match$1[0];
        let b = match$1[1];
        let c = match$1[2];
        return {
          TAG: "Ok",
          _0: [
            a,
            b,
            c
          ]
        };
      }
    }
    return {
      TAG: "Error",
      _0: {
        NAME: "UnexpectedJsonType",
        VAL: [
          [],
          "array[3]",
          json
        ]
      }
    };
  });
}

export {
  fill,
  map,
  reduce,
  zipWith,
  jsonCodec,
}
/* No side effect */
